import React from 'react'
import * as styles from './index.module.css'
import Product from '../ProductSnippet'
import { dynamicSort } from '../../utils'

export default ({ title, subtitle, components }) => {
  return (
    <div className="gray-wrapper-bg">
      <div className="wrapper">
        <div className={styles.container}>
          <h2 className={styles.title}>{title}</h2>

          <div className={styles.subtitle}>{subtitle.subtitle}</div>
          <section className={styles.backdrop} />

          <section className={styles.products}>
            {components.sort(dynamicSort('order')).map((block, index) => (
              <Product meta={block} key={index} />
            ))}
          </section>
        </div>
      </div>
    </div>
  )
}
